import styled from 'styled-components'

export const WeeklyPasswordWrapper = styled.div`
  width: 100%;
  padding: 24px 12px;

  .ant-input {
    border-radius: 8px 0 0 8px;
  }

  .ant-btn {
    border-radius: 0 8px 8px 0;
  }

  .ant-space-item {
    width: 100%;
  }

  .ant-divider {
    margin: 12px 0 16px 0;
  }
`
